export default __webpack_public_path__ + "static/media/ibmi.7e99b328.svg";